<script setup lang="ts">

import { AppSelect } from '@shared/ui/selects'
import { AppInput } from '@shared/ui/inputs'
import { BtnPrimary } from '@shared/ui/buttons'

import { useFiltersApiTokens } from '../../model/api-tokens/filters-api-tokens.hook'

defineOptions({
  name: 'FiltersApiTokens',
})

const {
  refUserId,
  refSearch,
  userOptions,
  canFilterByUser,
  isLoading,
  openCreateModal,
} = useFiltersApiTokens()
</script>

<template>
  <div class="box-filters-api-tokens">
    <div class="box-filters-api-tokens__fields">
      <AppInput
        v-model="refSearch"
        label="Search"
        placeholder="Search"
      />

      <AppSelect
        v-if="canFilterByUser"
        v-model="refUserId"
        :options="userOptions"
        label="User"
        placeholder="All users"
        :disabled="isLoading"
        clearable
      />
    </div>

    <BtnPrimary
      text="Create token"
      color="emerald"
      element-width="auto"
      :disabled="isLoading"
      @click="openCreateModal"
    />
  </div>
</template>

<style scoped lang="scss" src="./FiltersApiTokens.scss" />
